<template>
    <div class=" overflow-auto h-full">
        <div class="flex flex-wrap sm:flex-nowrap items-center justify-between my-4 lg:my-8">
            <!-- title -->
            <div class="order-1 flex-grow flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"
                    class="block w-8 h-8 stroke-current text-navy">
                    <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
                        <path
                            d="M12.75 15.75h3v4.5l4.5-4.5h1.494a1.506 1.506 0 0 0 1.506-1.506V2.25a1.5 1.5 0 0 0-1.5-1.5h-12a1.5 1.5 0 0 0-1.5 1.5v4.5m11.625 1.125h0"
                            fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                        <path
                            d="M19.875 7.875a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375m-7.5 0h0m0 0a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375m3.75 0h0m0 0a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375"
                            fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                        <circle cx="6.75" cy="13.125" r="3.375" fill="none" stroke-linecap="round"
                            stroke-linejoin="round" stroke-width="2"></circle>
                        <path d="M12.75 23.25a6.054 6.054 0 0 0-12 0" fill="none" stroke-linecap="round"
                            stroke-linejoin="round" stroke-width="2"></path>
                    </g>
                </svg>

                <span class="ml-2 text-navy font-bold leading-7 text-2xl">
                    Users
                </span>
            </div>
            <!-- Back to Farmers -->
            <div class="order-2 sm:order-3 sm:mr-3 ">
                <inertia-link
                    class="flex items-center justify-center w-7 h-7 rounded-full bg-navy hover:bg-navy-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-navy-light"
                    :href="route('app.user.index')">
                    <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"
                        class="block w-7 h-7 stroke-current text-white">
                        <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
                            <path d="M7.501 11.997L16.501 11.997" fill="none" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="1.5"></path>
                            <path d="M11.251 15.747L7.501 11.997 11.251 8.247" fill="none" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="1.5"></path>
                        </g>
                    </svg>
                    <span class="sr-only">
                        User List
                    </span>
                </inertia-link>
            </div>
        </div>

        <flash-message />

        <div class="py-8 px-5 shadow border-b border-gray-200 mt-8 bg-white">
            <form @submit.prevent="store">
                <div class="lg:flex w-full">
                    <div class="p-2 lg:mx-4 lg:w-1/2">
                        <label class="block text-sm font-medium text-gray-700" for="first_name">
                            First name
                        </label>

                        <input
                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                            id="first_name" type="text" autocomplete="first_name" v-model="form.first_name">

                        <div class="text-red-600" v-if="form.errors.first_name">{{ form.errors.first_name }}</div>
                    </div>

                    <div class="p-2 lg:mx-4 lg:w-1/2">
                        <label class="block text-sm font-medium text-gray-700" for="last_name">
                            Last name
                        </label>

                        <input
                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                            id="last_name" type="text" autocomplete="last_name" v-model="form.last_name">

                        <div class="text-red-600" v-if="form.errors.last_name">{{ form.errors.last_name }}</div>
                    </div>
                </div>
                <div class="lg:flex w-full">
                    <div class="p-2 lg:mx-4 lg:w-1/2">
                        <label class="block text-sm font-medium text-gray-700" for="email">
                            Email
                        </label>

                        <input
                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                            id="email" type="email" autocomplete="email" v-model="form.email">

                        <div class="text-red-600" v-if="form.errors.email">{{ form.errors.email }}</div>
                    </div>

                    <div class="p-2 lg:mx-4 lg:w-1/2">
                        <label class="block text-sm font-medium text-gray-700" for="telephone">
                            Telephone
                        </label>

                        <input
                            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                            id="telephone" type="text" autocomplete="telephone" v-model="form.telephone">

                        <div class="text-red-600" v-if="form.errors.telephone">{{ form.errors.telephone }}</div>
                    </div>
                </div>

                <div class="flex py-2">
                    <div class="p-2 lg:mx-4">
                        <label for="enabled" class="flex items-center">
                            <input
                                class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                id="enabled" name="enabled" type="checkbox" v-model="form.enabled">
                            <span class="ml-2 text-sm font-medium text-gray-600">Enabled</span>
                        </label>
                    </div>

                    <div class="p-2 lg:mx-4">
                        <label for="welcome" class="flex items-center">
                            <input
                                class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                id="welcome" name="welcome" type="checkbox" v-model="form.welcome">
                            <span class="ml-2 text-sm font-medium text-gray-600">Send welcome email</span>
                        </label>
                    </div>
                </div>

                <div class="flex py-2">
                    <div class="p-2 lg:mx-4">
                        <label class="block text-sm font-medium text-gray-700" for="role">
                            Role
                        </label>

                        <select
                            class="rounded border-gray-300 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 focus:placeholder-gray-400 sm:text-sm"
                            v-model="form.role">
                            <option value="">Select role</option>
                            <option v-for="(role, index) in roles" v-bind:key="index" v-bind:value="index">{{role}}
                            </option>
                        </select>

                        <div class="text-red-600" v-if="form.errors.role">{{ form.errors.role }}</div>
                    </div>

                    <div class="p-2 lg:mx-4"
                        v-if="$page.props.auth.user.role == 'admin' && ['consultant', 'consultant_user', 'contractor', 'soil_sampler', 'lab_user'].includes(form.role)">
                        <label class="block text-sm font-medium text-gray-700" for="organisation">
                            Organisation
                        </label>

                        <select
                            class="rounded border-gray-300 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 focus:placeholder-gray-400 sm:text-sm"
                            v-model="form.organisation" v-if="['consultant', 'consultant_user', 'soil_sampler'].includes(form.role)"
                        >
                            <option v-for="(organisation, key) in advisors" v-bind:key="key" v-bind:value="key">
                                {{organisation}}</option>
                        </select>

                        <select
                            class="rounded border-gray-300 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 focus:placeholder-gray-400 sm:text-sm"
                            v-model="form.organisation" v-if="form.role == 'contractor'"
                        >
                            <option v-for="(organisation, key) in contractors" v-bind:key="key" v-bind:value="key">
                                {{organisation}}</option>
                        </select>

                        <select
                            class="rounded border-gray-300 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 focus:placeholder-gray-400 sm:text-sm"
                            v-model="form.organisation" v-if="form.role == 'lab_user'"
                        >
                            <option v-for="(organisation, key) in link_labs" v-bind:key="key" v-bind:value="key">
                                {{organisation}}</option>
                        </select>

                        <div class="text-red-600" v-if="form.errors.organisation">{{ form.errors.organisation }}</div>
                    </div>

                    <div class="p-2 lg:mx-4" v-if="form.role == 'farm_owner'">
                        <label class="block text-sm font-medium text-gray-700" for="farm">
                            Farmer
                        </label>

                        <select
                            class="rounded border-gray-300 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 focus:placeholder-gray-400 sm:text-sm"
                            required v-model="form.farmer">
                            <option v-for="(farmer, key) in farmers" v-bind:key="key" v-bind:value="key">{{farmer}}
                            </option>
                        </select>

                        <div class="text-red-600" v-if="form.errors.farmer">{{ form.errors.farmer }}</div>
                    </div>
                </div>

                <div class="flex justify-end p-2 lg:mx-4">
                    <button type="submit"
                        class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        :disabled="form.processing">
                        Save User
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/App";
import { useForm } from '@inertiajs/inertia-vue3'

export default {
    layout: [AppLayout],
    props: {
        roles: Object,
        advisors: Object,
        contractors: Object,
        farmers: Object,
        link_labs: Object,
    },

    setup() {
        const form = useForm({
            first_name: "",
            last_name: "",
            email: "",
            telephone: "",
            enabled: true,
            welcome: true,
            role: "",
            organisation: "",
            farmer: "",
        })

        return { form }
    },

    data() {
        return {
        };
    },

    computed: {
    },

    created() {
    },

    methods: {
        store() {
            this.form.post(route('app.user.store'), {
                onSuccess: () => {
                    this.form.reset();
                }
            })
        }
    },
};
</script>
